module.exports = {
  values: { xs: 0, sm: 640, md: 768, lg: 1025, xl: 1280 },
}
